module.exports = __webpack_public_path__ + "img/foxieriver.4e492146.png";